export function urlToSubpage(accountType, pageUrl, type, claimGroup) {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}